varying vec2 vUv; 
varying vec3 vNormal; 
varying vec3 vPos; 
varying vec3 vWorldPos; 
uniform float u_power;
uniform float u_fog;

void main()
{
    vec2 ndc = (vUv -0.5)*2.;
    ndc *=100.;
    ndc = clamp(ndc, 0., 1.);

    float alpha = vWorldPos.y+u_fog;
    alpha = clamp(alpha, 0., 1.);
    gl_FragColor = vec4(vec3(0.9137254901960784, 0.592156862745098, 0.5686274509803921)*u_power*0.3, alpha);
}